import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../store';

export const selectDeviceSlice = (state: AppState) => state.devices.devices;
export const selecDevicesStatusSlice = (state: AppState) => state.devices.devicesStatus;

export const getDevices = createSelector(selectDeviceSlice, (devices) => devices);
export const isDevicesLoading = createSelector(selecDevicesStatusSlice, (status) => status === 'loading');
export const hasDevicesFailed = createSelector(selecDevicesStatusSlice, (status) => status === 'error');
